import { render } from "./BentukSuratRadio.vue?vue&type=template&id=d25162e2&scoped=true"
import script from "./BentukSuratRadio.vue?vue&type=script&lang=js"
export * from "./BentukSuratRadio.vue?vue&type=script&lang=js"

import "./BentukSuratRadio.vue?vue&type=style&index=0&id=d25162e2&lang=scss&scoped=true"

import exportComponent from "/Users/mymac/Documents/Digitala/Perki/newest-perki/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d25162e2"]])

export default __exports__